import styled from 'styled-components'
import { ScoreVariant } from './TransportScoreCard.types'

export const ScoreCard = styled.div<{ $variant?: ScoreVariant }>`
  padding: 20px;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid
    ${({ theme, $variant }) => {
      const colors = {
        primary: theme.colors.primary,
        success: theme.colors.success,
        warning: theme.colors.warning,
        danger: theme.colors.danger,
      }
      return colors[$variant || 'primary'] + '30'
    }};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: ${({ theme, $variant }) => {
      const colors = {
        primary: theme.colors.primary,
        success: theme.colors.success,
        warning: theme.colors.warning,
        danger: theme.colors.danger,
      }
      return colors[$variant || 'primary']
    }};
  }
`

export const ScoreHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const ScoreTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ScoreValue = styled.div<{ $size?: 'small' | 'medium' | 'large' }>`
  font-size: ${({ $size }) =>
    $size === 'large' ? '48px' : $size === 'medium' ? '32px' : '24px'};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1;
`

export const ScoreLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 4px;
`
